import OtpInput from "react18-input-otp";

export interface OTPSectionProps {
	otpValue: string;
	onOtpChange: (otp: string) => void;
	/** Why the last code was refused, shown under the boxes. */
	error?: string | null;
}

/**
 * OTPSection Component
 *
 * Renders a 6-digit OTP input field
 *
 * @param otpValue - Current OTP value
 * @param onOtpChange - Callback when OTP changes
 * @param error - Why the last code was refused, if it was
 */
export const OTPSection = ({
	otpValue,
	onOtpChange,
	error,
}: OTPSectionProps) => {
	return (
		<div className="opt-cont" data-testid="otp-container">
			<OtpInput
				value={otpValue}
				onChange={onOtpChange}
				shouldAutoFocus={true}
				autoComplete="one-time-code"
				numInputs={6}
				isInputNum={true}
				inputStyle="otp-number-input"
				containerStyle="otp-verification"
				hasErrored={Boolean(error)}
				errorStyle="otp-number-input--error"
			/>
			{error && (
				<p className="otp-inline-error" role="alert" data-testid="otp-inline-error">
					{error}
				</p>
			)}
		</div>
	);
};
